// Wersja Regulaminu i Polityki prywatnosci, ktora uzytkownik akceptuje przy rejestracji.
// MUSI byc zgodna z `TERMS_VERSION` w `backend/auth.py` — backend zapisuje ja jako dowod
// zawarcia umowy (`users.terms_version`). PODBIC OBIE przy kazdej zmianie tresci
// /regulamin albo /polityka-prywatnosci, inaczej dowod wskazuje zla wersje dokumentu.
export const TERMS_VERSION = "2026-05-07";
